import React from "react";

// Drucken laeuft ueber den Browser (window.print); der frueher hier
// auskommentierte Serverweg ist entfernt. Knopf statt div (#178), Beschriftung
// ohne die versehentlichen Anfuehrungszeichen.
const ResultsPrintButton = () => {
  if ("function" !== typeof window.print) {
    return null;
  }

  return (
    <button
      type="button"
      className="jm-action-button jm-print-button"
      onClick={() => window.print()}
    >
      PDF erstellen
    </button>
  );
};

export default ResultsPrintButton;
